import * as React from 'react';
import { MenuConfig } from '@tencent/workbench';
import i18n from '@i18next/i18n';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import cloneIcon from '@tencent/docs-design-resources/icon/desktop/svg/toolbar_duplicate_outline_24.svg';
import { MenuKey } from '../../schema/menu-schema/common';

export const MENU_CONFIGS: MenuConfig[] = [
    {
        name: MenuKey.GENERATE_COPIES_HOR,
        content: i18n.t<string>('生成副本'),
        respectOffline: true,
        icon: <img src={cloneIcon} style={{ width: '24px', height: '24px' }} />,
    },
    {
        name: ActionType.GENERATE_COPIES,
        content: i18n.t<string>('生成副本'),
        respectOffline: true,
    },
];
